export default 'fonts/ab0c37fa12f6ff84679d50e064b35da8.ttf';